// ** MUI Imports
import { styled, useTheme } from '@mui/material/styles'
import MuiAppBar from '@mui/material/AppBar'
import MuiToolbar from '@mui/material/Toolbar'

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  transition: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 6),
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  minHeight: theme.mixins.toolbar.minHeight,
  maxHeight: theme.mixins.toolbar.minHeight,
  height: theme.mixins.toolbar.minHeight,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}))

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  width: '100%',
  padding: '0 !important',
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  minHeight: `${theme.mixins.toolbar.minHeight}px !important`,
  maxHeight: `${theme.mixins.toolbar.minHeight}px !important`,
  height: `${theme.mixins.toolbar.minHeight}px !important`
}))

const LayoutAppBar = props => {
  // ** Props
  const { settings, appBarProps, appBarContent: userAppBarContent } = props

  // ** Hooks
  const theme = useTheme()

  // ** Vars
  const { appBar, contentWidth } = settings

  if (appBar === 'hidden') {
    return null
  }
  let userAppBarStyle = {}

  if (appBarProps && appBarProps.sx) {
    userAppBarStyle = appBarProps.sx
  }
  const userAppBarProps = Object.assign({}, appBarProps)

  delete userAppBarProps.sx

  return (
    <AppBar
      elevation={0}
      color='default'
      className='layout-navbar'
      sx={{
        background: {
          xs: `linear-gradient(120deg, #ffffff 0%, #ffffff max(calc(100% - 900px), 143px), transparent max(calc(100% - 900px), 143px)) no-repeat, #1B205C`,
          sm: `linear-gradient(120deg, #ffffff 0%, #ffffff max(calc(100% - 900px), 172px), transparent max(calc(100% - 900px), 172px)) no-repeat, #1B205C`
        },
        backgroundSize: '100% 100%',
        backgroundPosition: 'right top',
        boxShadow: theme.shadows[3],
        position: 'relative',

        ...userAppBarStyle
      }}
      position='static'
      {...userAppBarProps}
    >
      <Toolbar
        className='navbar-content-container'
        sx={{
          ...(contentWidth === 'boxed' && {
            '@media (min-width:1440px)': { maxWidth: `calc(1440px - ${theme.spacing(6)} * 2)` }
          })
        }}
      >
        {(userAppBarContent && userAppBarContent(props)) || null}
      </Toolbar>
    </AppBar>
  )
}

export default LayoutAppBar
